<template>
  <div class="article-edit-container">
    <div>
      <bread-crumb />
    </div>
    <div class="global-table-container">
      <a-row>
        <a-col :span="12">
          <a-row>
            <a-col :span="4">
              任务名称：
            </a-col>
            <a-col :span="18">
              {{ data.task_name }}
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-row>
            <a-col :span="4">
              任务类型：
            </a-col>
            <a-col :span="18">
              {{ data.task_type_name }}
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-row>
            <a-col :span="4">
              药企：
            </a-col>
            <a-col :span="18">
              {{ data.company_name }}
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-row>
            <a-col :span="4">
              任务期限：
            </a-col>
            <a-col :span="18">
              {{ data.time }}
            </a-col>
          </a-row>
        </a-col>
       <!-- <a-col :span="12">
          <a-row>
            <a-col :span="4">
              反馈资料：
            </a-col>
            <a-col :span="18">
              {{ data.after_survey_name||'无' }}
            </a-col>
          </a-row>
        </a-col> -->
        <!-- <a-col :span="24">
          <a-row>
            <a-col :span="2">
              任务介绍：
            </a-col>
            <a-col :span="15">
              <a-textarea
                :value="data.content"
                :autosize="{ minRows: 2, maxRows: 6 }"
                disabled
              />
            </a-col>
          </a-row>
        </a-col> -->
   <!--     <a-col :span="24">
          <a-row>
            <a-col :span="2">
              任务要求：
            </a-col>
            <a-col :span="15">
              <a-textarea
                :value="data.require_desc"
                :autosize="{ minRows: 2, maxRows: 6 }"
                disabled
              />
            </a-col>
          </a-row>
        </a-col> -->

        <a-col :span="24">
          <a-row>
            <a-col :span="2">
              任务资料：
            </a-col>
            <a-col :span="15">
              <a-table
                :columns="columns1"
                :data-source="data.datas"
                size="small"
                :row-key="record => record.id"
                :pagination="false"
                bordered
              />
            </a-col>
          </a-row>
        </a-col>
		<a-col :span="24">
		  <a-row>
		    <a-col :span="2">
		      推广员：
		    </a-col>
		    <a-col :span="15">
		      <el-select v-model="promoter_id" clearable  placeholder="请选择">
		          <el-option
		            v-for="item in options"
		            :key="item.promoter_id"
		            :label="item.user_nickname"
		            :value="item.promoter_id">
		          </el-option>
		        </el-select>
				<el-button type="primary" icon="el-icon-search" style="margin-left: 20px;" @click="search">搜索</el-button>
		    </a-col>
		  </a-row>
		</a-col>
        <a-col :span="24">
          <a-row>
            <a-col :span="2">
              执行明细：
            </a-col>
            <a-col :span="20">
              <a-table
              class="boder"
                :columns="columns2"
                :data-source="data.promoters"
                size="small"
                :row-key="record => record.tableId"
                :pagination="false"
				bordered
				:scroll="{ x: 1680, y: 450 }"
              >
                <a-checkbox
                  slot="check"
                  :indeterminate="indeterminate"
                  :checked="isCheckAll"
                  @change="checkAll"
                >
                  编号
                </a-checkbox>;
              </a-table>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <div class="component-form-button">
        <a-button
          class="cancel-button"
          shape="round"
          type="primary"
          :loading="btnIsLoading1"
          @click="onSubmit"
        >
          批量审核
        </a-button>
        <a-button
          class="cancel-button cancel-button-width"
          shape="round"
          @click="onCancel"
        >
          返回
        </a-button>
      </div>
    </div>

    <!--  -->
    <a-modal
      v-if="feedbackData"
      title="医生反馈"
      :visible="visible"
      ok-text=" "
      ok-type="link"
      @cancel="handleCancel"
    >
      <div class="feedbackwrapper">
        <a-row v-if="feedbackData.feedback.content">
          <a-col
            :span="6"
            class="feed-title"
          >
            任务反馈
          </a-col>
          <a-col :span="18">
            {{ feedbackData.feedback.content }}
          </a-col>
        </a-row>

        <a-row v-if="feedbackData.before_list.length>0">
          <a-col
            :span="6"
            class="feed-title"
          >
            调研报告
          </a-col>
          <a-col

            :span="18"
          >
            <div
              v-for="option in feedbackData.before_list"
              :key="option.id"
            >
              <div>{{ option.name }}</div>
              <div
                v-for="(item, index) in option.survey_list"
                :key="index"
              >
                <div>{{ index + 1 }}.{{ item.question }}</div>
                <div v-if="item.type !== 0">
                  <div
                    v-for="(obj, ind) in item.option_str"
                    :key="ind"
                  >
                    <a-icon
                      v-if="obj.check == 0"
                      type="border"
                    />
                    <a-icon
                      v-if="obj.check == 1"
                      type="check-square"
                    />
                    {{ String.fromCharCode(65 + ind) }} {{ obj.option_title }}
                  </div>
                </div>
                <div v-if="item.type == 0">
                  文本回答：{{ item.option_str }}
                </div>
              </div>
            </div>
          </a-col>
        </a-row>

        <a-row v-if="feedbackData.after_info.name">
          <a-col
            :span="6"
            class="feed-title"
          >
            会后调研
          </a-col>
          <a-col :span="18">
            <div>{{ feedbackData.after_info.name }}</div>
            <div
              v-for="(item, index) in feedbackData.after_info.survey_list"
              :key="index"
            >
              <div>{{ index + 1 }}.{{ item.question }}</div>
              <div v-if="item.type != 0">
                <div
                  v-for="(obj, ind) in item.option_str"
                  :key="ind"
                >
                  <a-icon
                    v-if="obj.check == 0"
                    type="border"
                  />
                  <a-icon
                    v-if="obj.check == 1"
                    type="check-square"
                  />
                  {{ String.fromCharCode(65 + ind) }} {{ obj.option_title }}
                </div>
              </div>
              <div v-if="item.type == 0&&item.option_str!=''">
                文本回答：{{ item.option_str }}
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row
          v-if="!Array.isArray(feedbackData.paper_list)"
          class="paper-wrapper"
        >
          <a-col
            :span="6"
          >
            <div class="feed-title">
              答题反馈
            </div>
            <div class="score">
              ({{ feedbackData.paper_list.paper_info.paper_score }}积分)
            </div>
          </a-col>
          <a-col :span="18">
            <div>
              {{ feedbackData.paper_list.paper_info.name }}
              <div
                v-for="(item,index) in feedbackData.paper_list.paper_question_list.filter(item=>item.is_true===0)"
                :key="item.id"
              >
                <div>
                  {{ index+1 }}.{{ item.paper_title }}
                  <div
                    v-for="(option,index1) in item.option_list"
                    :key="option.id"
                  >
                    <a-icon
                      v-if="option.is_check == 0"
                      type="border"
                    />
                    <a-icon
                      v-if="option.is_check == 1"
                      type="check-square"
                    />
                    {{ String.fromCharCode(65 + index1) }} {{ option.option_title }}
                  </div>
                  <div class="correct-wrap">
                    正确答案为【<span class="correct">{{ getCorrect(item.option_list) }}</span>】
                  </div>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </a-modal>
	
	<el-dialog
	  title="温馨提示"
	  :visible.sync="dialogVisible"
	  width="50%"
	  custom-class="class1"
	 >
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
		  <el-form-item label="驳回原因" prop="reason">
		    <el-input v-model="ruleForm.reason"></el-input>
		  </el-form-item>
		</el-form>
	</div>
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="dialogVisible = false" round>再看看</el-button>
	    <el-button type="primary" @click="reject" round>确认驳回</el-button>
	  </span>
	</el-dialog>
  </div>
</template>
<script>
const renderContent = (value, row, index) => {
  const obj = {
    children: value,
    attrs: {},
  };
  if(row.isMerge){
    obj.attrs.rowSpan  = row.rowSpan;
  }else{
    obj.attrs.rowSpan  = 0;
  }
  return obj;
};

const uuidv1 = require('uuid/v1');
import { formData } from './../data/index';
import testData from './../data/test';
import RadioComponent from '../components/radio';
export default {
  components: {RadioComponent},
  data() {
    return {
		ruleForm:{reason:''},
		 rules: {
		          reason: [
		            { required: true, message: '请输入原因', trigger: 'blur' },
		          ],},
	dialogVisible:false,
      indeterminate: false,
      checkedList: [],
      plainOptions: [],
      isCheckAll: false,
      btnIsLoading1: false,
      // 蒙层
      visible: false,
      // 反馈数据
      feedbackData: '',
      // 分割线
      showData: [],
	  promoter_id:'',
	  options: [],
      columns1: [
        {
          title: '编号',
          dataIndex: 'id',
        },
        {
          title: '类型',
          dataIndex: 'link_datas.obj_type_text',
        },
        {
          title: '标题',
          dataIndex: 'link_datas.name',
        },
		{
		  title: '关联产品',
		  dataIndex: 'product.title',
		},
		{
		  title: '使用次数',
		  dataIndex: 'allow_use_times',
		  customRender: (value, row, index) => {
		    const obj = {
		      children: value===0?'不限制次数':value,
			  attrs: {},
		    };
		    // if(row.isMerge){
		    //   obj.attrs.rowSpan  = row.rowSpan;
		    // }else{
		    //   obj.attrs.rowSpan  = 0;
		    // }
		    return obj;
		  },
		},
      ],
      columns2: [
        {
          dataIndex: 'doctorId',
          width: 100,
          slots: { title: 'check'},
		   fixed: "left",
          customRender: (value, row, index) => {
            const obj = {
              children: null,
              attrs: {},
            };
            obj.children =
                <a-checkbox-group disabled ={row.status !== 5 }
                  options={[`${value?value:'无'}`]}
                  on-change={
                    (checkedList)=>{
                      console.log('data -> checkedList', checkedList);
                      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
                      this.isCheckAll = checkedList.length === this.plainOptions.length;
                    }
                  }
                  v-model={this.checkedList}
                />;
            if(row.isMerge){
              obj.attrs.rowSpan  = row.rowSpan;
            }else{
              obj.attrs.rowSpan  = 0;
            }
            return obj;
          },
        },
		
        {
		      width: 100,
          title: '推广人名称',
		   fixed: "left",
          dataIndex: 'user_realname',
          customRender: renderContent,
        },
		{
			width: 130,
		  title: '分配任务数量',
		  dataIndex: 'assigned_num',
		  customRender: renderContent,
		},
        {
			    width: 110,
          title: '推广医生数量',
          dataIndex: 'doctor_count',
          customRender: renderContent,
        },
        {
			    width: 100,
          title: '推广员电话',
          dataIndex: 'mobile',
          customRender: renderContent,
        },
        {
			    width: 100,
          title: '医生',
          dataIndex: 'user_realname1',
		  customRender:  (value, row, index) => {
			 const obj = {
			   children: value,
			   attrs: {},
			 };
			 if(row.isMerge){
			   obj.attrs.rowSpan  = row.rowSpan;
			 }else{
			   obj.attrs.rowSpan  = 0;
			 }
			 return obj;
		  },
        },
		{
			width: 300,
		  title: '资料名称',
		  dataIndex: 'name',
		},
        {
			width: 80,
          title: '观看次数',
          dataIndex: 'read_hits',
        },
        {
			width: 80,
          title: '观看时长',
          dataIndex: 'read_time_text',
        },
		{
			width: 80,
		  title: '要求时长',
		  dataIndex: 'need_seconds_text',
		},
		{
			width: 200,
		  title: '反馈',
		  dataIndex: 'feedback',
		},
        // {
        //   title: '反馈',
        //   dataIndex: '',
        //   customRender: (value, row, index) => {
        //     const obj = {
        //       children: row.rowSpan ? (
        //         <a-button
        //           type="link"
        //           on-click={() => {
        //             let feedbackid = row.doctor_id;
        //             this.getFeedBack(feedbackid);
        //           }}
        //         >
        //           查看
        //         </a-button>
        //       ) : (
        //         '暂无'
        //       ),
        //       attrs: {},
        //     };
        //     return obj;
        //   },
        // },
        {
			    width: 100,
          title: '完成时间',
          dataIndex: 'finish_time',
          customRender: (value, row, index) => {
            const obj = {
              children: value? value : '-',
              attrs: {},
            };
           if(row.isMerge){
             obj.attrs.rowSpan  = row.rowSpan;
           }else{
             obj.attrs.rowSpan  = 0;
           }
            return obj;
          },
        },
        {
			    width: 100,
          title: '状态',
          dataIndex: 'task_doctor_status_name',
		  customRender: renderContent,
          // customRender: (value, row, index) => {
          //   const obj = {
          //     children: null,
          //     attrs: {},
          //   };

          //   if(value === 3){
          //     obj.children = (<radio-component isShow={this.showData[index]}
          //       on-change={
          //         (e)=>{
          //           this.$set(this.showData, index, !this.showData[index]);
          //           row.radioStatus=e.target.value;
          //           console.log('data -> this.showData[index]', this.showData[index]);
          //         }
          //       }
          //       on-changeInput={
          //         (e)=>{
          //           row.reason=e.target.value;
          //         }
          //       }></radio-component>);
          //   }else{
          //     obj.children = row.task_status_name;
          //   }
          //   if(row.isMerge){
          //     obj.attrs.rowSpan  = row.rowSpan;
          //   }else{
          //     obj.attrs.rowSpan  = 0;
          //   }
          //   return obj;
          // },
        },
        {
          width: 100,
          title: '操作',
          dataIndex: 'operation',
		      fixed: "right",
          scopedSlots: { customRender: 'operation' },
          customRender: (value, row, index) => {
            const obj = {
              children: null,
              attrs: {},
            };
            if(row.status === 5){
              
       //          <a href="javascript:;" on-click={ async()=>{
       //            let data={
       //              task_id: this.$route.query.id,
       //              id: row.id,
       //              task_status: row.radioStatus?row.radioStatus:'5',
       //              reason: row.reason,
       //              scores: row.radioStatus==='4'?'0':row.scores,
       //            };
       //            let result=await this.$http.post('/task/checkOne', data);
       //            if(result.data.status===1){
       //              let result = await this.$http.post('/task/info', { id: this.$route.query.id });
       //              if (result.data.status === 1) {
       //                let temp = result.data.data;
       //                this.data = temp.info;
					  // this.data.datas.map((item)=>{
						 //  item.product_title=item.product.title
					  // })
       //                this.data.time=`${this.$Format(temp.info.start_time)} ~ ${this.$Format(temp.info.end_time)}`;
       //                let promoters=[];
       //                let num=0;
       //                let isMerge=false;
       //                let promoterId='';
       //                temp.promoter_list.forEach((item, index)=>{
       //                  this.showData.push(false);
       //                  if(item.doctor_list.length>0){
       //                   item.doctor_list.forEach((list, listIndex)=>{
       //                    list.task_doctor_data.forEach((doctor, doctorIndex)=>{
       //                   	 if(list.id!==promoterId){
       //                   	   promoterId=list.id;
       //                   	   isMerge=true;
       //                   	 }else{
       //                   	   isMerge=false;
       //                   	 }
       //                     this.showData.push(false);
       //                     promoters.push({
       //                     ...item, tableId: uuidv1(),
       //                   	  radioStatus: '5',
       //                      isMerge: isMerge,
       //                      user_realname1: list.user_realname,
       //                      rowSpan: list.task_doctor_data.length,
       //                      finish_time: this.$moment.unix(list.finish_time).format('YYYY-MM-DD'),
       //                      task_doctor_status_name:list.task_doctor_status_name,
       //                   	setRow: num++,
       //                     read_time_text:doctor.read_time_text,
       //                     need_seconds_text: doctor.taskDataInfo.link_datas.need_seconds_text,
       //                      read_hits: doctor.read_hits,
       //                      name: doctor.taskDataInfo.link_datas.name,
							//  status:list.link_datas.status,
       //                      feedback:doctor.feedback,
       //                     });
       //                   	 });
       //                   });
       //                  }else{
       //                    promoters.push({...item,  tableId: uuidv1(), radioStatus: '5', user_realname1: '暂无', read_time_text: '暂无', read_hits: '暂无', rowSpan: undefined, setRow: num++, isMerge: true});
       //                  }

       //                });
					  
       //                this.data.promoters=promoters;
       //                let result1 =await  this.$http.post('/task/getTaskDatas', {task_id: this.$route.query.id });
       //                if (result1.data.status === 1) {
       //                  let data1 = result1.data.data.data_list;
       //                  this.$set(this.data, 'datas', data1);
       //                }
       //              }
       //            }
       //          }}>提交</a>;
				obj.children = <div><a href="javascript:;" on-click={()=>{
                  let data={
                    task_doctor_id: row.doctorId,
                  };
					 this.$confirm('是否确认工作报告通过审核，确认后将不可更改审核状态。', '温馨提示', {
					          confirmButtonText: '确认通过',
					          cancelButtonText: '再想想',
					          type: 'warning'
					        }).then(async() => {
					          let result = await this.$http.post('/task/checkOne', data);
					          if(result.data.status===1){
					            let result = await this.$http.post('/task/info', { id: this.$route.query.id });
					            if (result.data.status === 1) {
					              let temp = result.data.data;
					              this.data = temp.info;
					          					  this.data.datas.map((item)=>{
					          						  item.product_title=item.product.title
					          					  })
					              this.data.time=`${this.$Format(temp.info.start_time)} ~ ${this.$Format(temp.info.end_time)}`;
					              let promoters=[];
					              let num=0;
					              let isMerge=false;
					              let promoterId='';
					              temp.promoter_list.forEach((item, index)=>{
					                this.showData.push(false);
					                if(item.doctor_list.length>0){
					                 item.doctor_list.forEach((list, listIndex)=>{
					                  list.task_doctor_data.forEach((doctor, doctorIndex)=>{
					                 	 if(list.id!==promoterId){
					                 	   promoterId=list.id;
					                 	   isMerge=true;
					                 	 }else{
					                 	   isMerge=false;
					                 	 }
					                   this.showData.push(false);
					                   promoters.push({
					                   ...item, tableId: uuidv1(),
					                 	  radioStatus: '5',
					                    isMerge: isMerge,
					                    user_realname1: list.user_realname,
					                    rowSpan: list.task_doctor_data.length,
					                    finish_time: list.finish_time_txt,
					                    task_doctor_status_name:list.task_doctor_status_name,
					                 	setRow: num++,
					                   read_time_text:doctor.read_time_text,
					                   need_seconds_text: doctor.taskDataInfo.link_datas.need_seconds_text,
					                    read_hits: doctor.read_hits,
					          							 doctorId:list.id,
					          							   status:list.status,
					                    name: doctor.taskDataInfo.link_datas.name,
					                    feedback:doctor.feedback,
					                   });
					                 	 });
					                 });
					                }else{
					                  promoters.push({...item,  tableId: uuidv1(), radioStatus: '5', user_realname1: '暂无', read_time_text: '暂无', read_hits: '暂无', rowSpan: undefined, setRow: num++, isMerge: true});
					                }
					          
					              });
					          					  
					              this.data.promoters=promoters;
					              let result1 =await  this.$http.post('/task/getTaskDatas', {task_id: this.$route.query.id });
					              if (result1.data.status === 1) {
					                let data1 = result1.data.data.data_list;
					                this.$set(this.data, 'datas', data1);
					              }
					            }
					          }
					        }).catch(() => {
					                   
					        });
				  
                  
                }}>审核</a> <a-divider type="vertical" /><a href="javascript:;"
            on-click={ async()=>{
				this.rejectdoctorId=row.doctorId
				this.dialogVisible=true
			}}
          >驳回</a></div>
            }else{
              obj.children = <div><a href="javascript:;" style="color:#C0C4CC;    cursor: not-allowed;">审核</a><a-divider type="vertical" /><a href="javascript:;"
           style="color:#C0C4CC;    cursor: not-allowed;">驳回</a></div>;
            }
            if(row.isMerge){
              obj.attrs.rowSpan  = row.rowSpan;
            }else{
              obj.attrs.rowSpan  = 0;
            }
            return obj;
          },
        },
      ],
      data: { },
      btnIsLoading: false,
	  rejectdoctorId:null,

    };
  },
  async mounted() {
    // 获取数据
    await this.getData(this.$route.query.id,'');
	 await this.geTaskPromoters(this.$route.query.id);
  },
  methods: {
	  async reject(){
		  let data={
		    task_doctor_id: this.rejectdoctorId,
			reason:this.ruleForm.reason,
			status:2
		  };
		  let result=await this.$http.post('/task/checkOne', data);
		  if(result.data.status===1){
			  this.dialogVisible=false
		    let result = await this.$http.post('/task/info', { id: this.$route.query.id });
		    if (result.data.status === 1) {
		      let temp = result.data.data;
		      this.data = temp.info;
		  					  this.data.datas.map((item)=>{
		  						  item.product_title=item.product.title
		  					  })
		      this.data.time=`${this.$Format(temp.info.start_time)} ~ ${this.$Format(temp.info.end_time)}`;
		      let promoters=[];
		      let num=0;
		      let isMerge=false;
		      let promoterId='';
		      temp.promoter_list.forEach((item, index)=>{
		        this.showData.push(false);
		        if(item.doctor_list.length>0){
		         item.doctor_list.forEach((list, listIndex)=>{
		          list.task_doctor_data.forEach((doctor, doctorIndex)=>{
		         	 if(list.id!==promoterId){
		         	   promoterId=list.id;
		         	   isMerge=true;
		         	 }else{
		         	   isMerge=false;
		         	 }
		           this.showData.push(false);
		           promoters.push({
		           ...item, tableId: uuidv1(),
		         	  radioStatus: '5',
		            isMerge: isMerge,
		            user_realname1: list.user_realname,
		            rowSpan: list.task_doctor_data.length,
		            finish_time: list.finish_time_txt,
		            task_doctor_status_name:list.task_doctor_status_name,
		         	setRow: num++,
		           read_time_text:doctor.read_time_text,
		           need_seconds_text: doctor.taskDataInfo.link_datas.need_seconds_text,
		            read_hits: doctor.read_hits,
		  							 doctorId:list.id,
		  							   status:list.status,
		            name: doctor.taskDataInfo.link_datas.name,
		            feedback:doctor.feedback,
		           });
		         	 });
		         });
		        }else{
		          promoters.push({...item,  tableId: uuidv1(), radioStatus: '5', user_realname1: '暂无', read_time_text: '暂无', read_hits: '暂无', rowSpan: undefined, setRow: num++, isMerge: true});
		        }
		  
		      });
		  					  
		      this.data.promoters=promoters;
		      let result1 =await  this.$http.post('/task/getTaskDatas', {task_id: this.$route.query.id });
		      if (result1.data.status === 1) {
		        let data1 = result1.data.data.data_list;
		        this.$set(this.data, 'datas', data1);
		      }
		    }
		  }
	  },
    // 获取正确答案
    getCorrect(data){
      let temp=data.map((item, index)=>{
        return {
          index: String.fromCharCode(65 + index),
          is_answer: item.is_answer,
        };
      }).filter((list)=>list.is_answer===1);
      return temp.map((item)=>item.index).join();
    },
	async search(){
		 await this.getData(this.$route.query.id,this.promoter_id);
	},
	async geTaskPromoters(id){
		let result = await this.$http.post('/task/getTaskPromoters', { task_id:id });
		if (result.data.status === 1) {
		 this.options = result.data.data.data_list;
		}
	},
    handleCancel() {
      this.visible = false;
      this.feedbackData = '';
    },
    // 获取反馈数据
    async getFeedBack(id) {
      let result = await this.$http.post('/task/getTaskDoctorFeedback', { id });
      if (result.data.status === 1) {
        this.visible = true;
        this.feedbackData = result.data.data;
        console.log(this.feedbackData);
      }
    },
    // 获取数据
    async getData(id,promoter_id) {
      // console.log(testData);
	  let data={
		  id:id,
		  promoter_id:promoter_id
	  }
      let result = await this.$http.post('/task/info', data);
      if (result.data.status === 1) {
		
		  
        let temp = result.data.data;
		
        this.data = temp.info;
        this.data.time=`${this.$moment.unix(temp.info.start_time).format('YYYY-MM-DD')} ~ ${this.$moment.unix(temp.info.end_time).format('YYYY-MM-DD')}`;
        let promoters=[];
        let num=0;
        let isMerge=false;
		 let isMerge1=false;
        let promoterId='';
		 let promoterId1='';
        this.plainOptions=[];
        temp.promoter_list.forEach((item, index)=>{
          if(item.task_status===3){
            this.plainOptions.push(String(item.id));
          }
          if(item.doctor_list.length>0){
            item.doctor_list.forEach((list, listIndex)=>{
				

			 list.task_doctor_data.forEach((doctor, doctorIndex)=>{
				 if(list.id!==promoterId){
				   promoterId=list.id;
				   isMerge=true;
				 }else{
				   isMerge=false;
				 }
              this.showData.push(false);
              promoters.push({
			  ...item, tableId: uuidv1(),
				radioStatus: '5',
			   isMerge: isMerge,
			   user_realname1: list.user_realname,
			   rowSpan: list.task_doctor_data.length,
			   finish_time: list.finish_time_txt,
			   task_doctor_status_name:list.task_doctor_status_name,
				setRow: num++,
               read_time_text:doctor.read_time_text,
               need_seconds_text: doctor.taskDataInfo.link_datas.need_seconds_text,
			    status:list.status,
               read_hits: doctor.read_hits,
               name: doctor.taskDataInfo.link_datas.name,
			   doctorId:list.id,
               feedback:doctor.feedback,
              });
				 });
            });
          }else{
            this.showData.push(false);
            promoters.push({...item,  tableId: uuidv1(), radioStatus: '5', user_realname1: '暂无', read_time_text: '暂无', read_hits: '暂无', rowSpan: undefined, setRow: num++, isMerge: true, doctor_num: 0});
          }
		  console.log(promoters)
          // console.log('this.showData111', this.showData);
          // console.log('promoters', promoters);
        });
        this.data.promoters=promoters;
        // console.log('getData -> this.data.promoters', this.data.promoters);
        let result1 = await this.$http.post('/task/getTaskDatas', {task_id: this.$route.query.id });
        if (result1.data.status === 1) {
          let data1 = result1.data.data.data_list;
          this.$set(this.data, 'datas', data1);
        }
      }
    },

    // 批量审核
    async onSubmit() {
      console.log('this.checkedList', this.checkedList);
      if(this.checkedList.length===0){
        this.$message.warning('请至少选择一项！');
        return;
      }
      let listData =[];
      this.checkedList.forEach((id)=>{
        id=Number(id);
        listData.push(this.data.promoters.find((item)=>item.doctorId===id));
      });
      console.log('listData', listData);
      let data={
        // task_id: this.$route.query.id,
        task_doctor_ids: [],
        // task_status: [],
        // reason: [],
        // scores: [],
      };
      listData.forEach((list)=>{
        data.ids.push(list.doctorId);
        // data.task_status.push(list.radioStatus);
        // data.reason.push(list.reason);
        // data.scores.push(list.scores);
      });
      this.btnIsLoading1 = true;
      console.log('data', data);
      let result=await this.$http.post('/task/checkPost', data);
      this.btnIsLoading1 = false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getData(this.$route.query.id,'');
        this.checkedList=[];
        this.isCheckAll=false;
        this.indeterminate=false;
      }
    },
    // 返回
    onCancel() {
      this.$router.back();
    },
    // 全选
    checkAll(e){
      Object.assign(this, {
        checkedList: e.target.checked ? this.plainOptions : [],
        indeterminate: false,
        isCheckAll: e.target.checked,
      });
    },
  },
};
</script>
<style>
  .boder .ant-table-small.ant-table-bordered .ant-table-tbody > tr > td:last-child {
    border-right: 1px solid #e8e8e8!important;
}
.class1 {
  border-radius: 30px;
}
</style>
<style scoped lang="scss">
.article-edit-container {
  .ant-col-12{
    margin-bottom: 30px;;
  }
 .ant-col-24{
    margin-bottom: 30px;
  }
  .btn-container {
    text-align: right;
    margin-top: 100px;
  }

}
.component-form-button {
  height: 80px;
  line-height: 80px;
  background: #f9f9fc;
 margin: 0px -24px;
    padding: 0 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  .cancel-button {
    float: right;
    margin-left: 10px;
    margin-top: 20px;
  }
   .cancel-button-width{
     width:104px;
   }
}

.feedbackwrapper{
    height: 500px;
    overflow-y: scroll;

    .feed-title{
      font-size: 15px;
      font-weight: 600;
    }
     .paper-wrapper{
      margin-top: 20px;
      margin-bottom: 20px;
      .score{
        color: #f5222d;
      }
      .correct-wrap{
        margin:10px 0;
 .correct{
        color: #f5222d;
      }
      }

    }

  }

</style>